import {Box, Card, Stack, Typography} from "@mui/material";
import React, {useContext, useState} from "react";
import {
  CONTEXT_ACTION_TYPE,
  DataStoreContext,
  initialState,
  SimulationSettingsPayload,
  STEP_ORDERS,
  STEPS,
  useStep,
  validateStepOutput
} from "../../contexts/OperatingTestContext";
import useMutation from "../../../../hooks/useMutation";
import Pjdb1TextField from "../../../../components/inputs/Pjdb1TextField";
import Pjdb1Button from "../../../../components/inputs/Pjdb1Button";
import {CustomWorldListItem as BaseCustomWorldListItem} from "../lists/CustomWorldListItem";
import {CustomWorldDocument} from "../../../../types/pj1dbApiWorld";
import {WorldDetailDialog} from "../details/WorldDetailDialog";

export default function SimulationSettingsStep() {
  if (!useIsShow()) {
    throw new Error('SimulationSettingsStep is not shown');
  }

  const {state, dispatch} = useContext(DataStoreContext);
  console.log('選択した機器', {
    '計算結果': state.equipmentStep.selectedData?.suggestionPattern,
    'ハンド': state.equipmentStep.selectedData?.hand,
    '爪': state.equipmentStep.selectedData?.fingertip,
    'アーム': state.searchCriteriaStep.selectedArm,
  });
  console.log('選択したカスタムワールド', state.customWorldStep.selectedCustomWorld);
  const [, setStep] = useStep();
  const {clear, formRef, isLoading, mutate} = useMutation({
      enableConfirm: false,
      onClear: () => {
        dispatch({
          type: CONTEXT_ACTION_TYPE.SIMULATION_SETTINGS,
          payload: {inputs: initialState.simulationStep.inputs} satisfies SimulationSettingsPayload,
        });
      },
      mutationFn: async () => {
        await new Promise((resolve) => {
          setTimeout(resolve, 1000)
        });
        console.log('mutationFn');
        return true;
      },
    })
  ;

  return (
    <Stack gap={4}>
      <Box display='flex' justifyContent='space-between' alignItems='center'>
        <Typography variant='h6' component='h2'>条件</Typography>
        <Pjdb1Button
          label='カスタムワールド選択'
          variant='text'
          color='inherit'
          onClick={() => {
            setStep(STEP_ORDERS[STEPS.SIMULATION_SETTINGS].PREV);
          }}
        />
      </Box>

      <Card sx={{p: 4}}>
        <form ref={formRef}>
          <Stack gap={2}>
            <Pjdb1TextField
              label="ダミー"
              name="dummy"
              required
              value={state.simulationStep.inputs.dummy}
              onChange={(e) => {
                dispatch({
                  type: CONTEXT_ACTION_TYPE.SIMULATION_SETTINGS,
                  payload: {inputs: {dummy: e.target.value}} satisfies SimulationSettingsPayload,
                });
              }}
            />
            <Box display='flex' flexWrap='wrap' justifyContent='center' gap={2}>
              <Pjdb1Button
                label='クリア'
                variant='contained'
                color='inherit'
                onClick={clear}
                isLoading={isLoading}
              />
              <Pjdb1Button
                label='シミュレーション実行開始'
                variant='contained'
                color='primary'
                onClick={() => {
                  mutate().catch(console.error);
                }}
                isLoading={isLoading}
              />
            </Box>
          </Stack>
        </form>
      </Card>
    </Stack>
  );
}

function useIsShow() {
  const {state} = useContext(DataStoreContext);
  return state.step === STEPS.SIMULATION_SETTINGS &&
    validateStepOutput(state, STEP_ORDERS[STEPS.SIMULATION_SETTINGS].PREV);
}

function CustomWorldListItem(props: { item: CustomWorldDocument }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <WorldDetailDialog
        open={open}
        worldId={props.item.attr["world-id"]}
        onClose={() => setOpen(false)}
      />
      <BaseCustomWorldListItem item={props.item} onClick={() => setOpen(true)}/>
    </>
  )
}
